import { FormikProps } from "formik";
import { useContext } from "react";
import {
  BlankMediaTypeApplicationListFilter,
  ItemViewModel,
} from "../../../../../generated/data-contracts";
import { isMobileView } from "../../../../shared/appStates/appStates";
import { FilterActions } from "../../../../shared/components/form";
import { AvisDropdown } from "../../../../shared/components/inputs";
import { AvisContext } from "../../../../shared/context";

interface IBlankMediaTypeApplicationsFilterFormProps {
  statuses: ItemViewModel[] | undefined;
  useTypes: ItemViewModel[] | undefined;
  bag: FormikProps<BlankMediaTypeApplicationListFilter>;
  loading: boolean;
  filtered: boolean;
}

export function BlankMediaTypeApplicationsFilterForm(
  props: Readonly<IBlankMediaTypeApplicationsFilterFormProps>,
) {
  const { bag, useTypes, statuses, loading, filtered } = props;
  const { res } = useContext(AvisContext);
  const classnameFields = isMobileView.value ? "col-10" : "col-5";

  return (
    <>
      <div className="row">
        <AvisDropdown<ItemViewModel, BlankMediaTypeApplicationListFilter>
          className={classnameFields}
          label={res("blankMedia_Application_filter_UseType")}
          options={useTypes}
          bag={bag}
          bagField="useType"
          disabled={loading}
          optionValue="id"
          optionLabel="name"
        />
      </div>
      <div className="row">
        <AvisDropdown<ItemViewModel, BlankMediaTypeApplicationListFilter>
          className={classnameFields}
          label={res("label_Status")}
          options={statuses}
          bag={bag}
          bagField="status"
          disabled={loading}
          optionValue="id"
          optionLabel="name"
        />
      </div>
      <FilterActions
        bag={bag}
        loading={loading}
        filtered={filtered}
        res={res}
      />
    </>
  );
}
